<template>
	<div class="watch-biometric-alert-view-resume">
		<spinner v-if="resume.loading"/>
		<error-box v-else-if="resume.error" :error="resume.error"/>
		<div v-if="!isEmpty(resume.data)" class="data">
			<div class="grid">
				<div class="value">
					<div class="label">{{ $t('labels.general.value') }}</div>
					<div class="value">{{ value }}&nbsp;<span v-html="units"></span></div>
				</div>
				<div class="events">
					<div class="label">{{ $t('labels.general.events') }}</div>
					<div class="value">{{ resume.data.events }}</div>
				</div>
				<div class="first">
					<div class="label">{{ $t('labels.general.first') }}</div>
					<div class="value">{{ resume.data.values.first.date | timeAgo(vue) }}</div>
				</div>
				<div class="last">
					<div class="label">{{ $t('labels.general.last') }}</div>
					<div class="value">{{ resume.data.values.last.date | timeAgo(vue) }}</div>
				</div>
			</div>
			<div class="resume-chart-wrapper" v-if="isBiometric">
				<resume-chart :first="resume.data.values.first" :readings="readings.data" :type="type_id"/>
				<spinner v-if="readings.loading" class="spinner"/>
			</div>
			<div class="resume-map-wrapper" v-if="isGeofencing">
				<resume-map :user_uid="user_uid" :watch_id="watch_id" :resume="resume.data"/>
			</div>
		</div>
	</div>
</template>

<script>
import ApiObject from '@/classes/api/ApiObject'
import ApiCollection from '@/classes/api/ApiCollection'
import Reading from '@/classes/Reading'
import Readings from '@/utils/readings'
import ResumeChart from '../alerts/ResumeChart'
import ResumeMap from '../alerts/ResumeMap'
export default {
	components: {
		ResumeChart,
		ResumeMap
	},
	props: [
		'user_uid',
		'watch_id',
		'type_id',
		'alert_id'
	],
	data () {
		return {
			vue: this,
			componentName: 'watch biometric alert history view resume',
			resume: new ApiObject(),
			readings: new ApiCollection(),
		}
	},
	computed: {
		value () {
			if (this.isEmpty(this.resume.data)) return ''
			switch (parseInt(this.type_id)) {
				case Readings.TYPE_BLOOD_PRESSURE:
					return `${this.resume.data.values.first.systolic} ${this.resume.data.values.first.diastolic}`
				case Readings.TYPE_FALLS:
					return this.$t('readings.falls.fall_detected')
				case Readings.TYPE_GEOFENCING:
					return `${this.resume.data.values.first.latitude} ${this.resume.data.values.first.longitude}`
				default:
					return this.resume.data.values.first.value
			}
		},
		units () {
			return Readings.readingTypes.get(parseInt(this.type_id)).unitHtml
		},
		isBiometric () {
			return parseInt(this.type_id) !== Readings.TYPE_GEOFENCING
		},
		isGeofencing () {
			return parseInt(this.type_id) === Readings.TYPE_GEOFENCING
		}
	},
	methods: {
		getResume () {
			this.resume.loading = true
			this.$api.alerts.getResume(this, this.user_uid, this.watch_id, this.type_id, this.alert_id)
				.then(response => {
					this.$log.info(this.componentName, 'alerts.getResume OK', response)()
					this.resume.data = response.body
					this.$nextTick(() => {
						this.getReadings()
					})
				}).catch(error => {
					this.$log.error(this.componentName, 'alerts.getResume ERROR', error)()
					this.resume.error = error
				}).finally(() => {
					this.resume.loading = false
				})
		},
		getReadings () {
			const first = this.resume.data.values.first
			const interval = {
				start: this.$moment(first.date).subtract(12, 'h').format(),
				end: this.$moment(first.date).add(12, 'h').format()
			}
			this.readings.loading = true
			this.$api.readings.getAllByTypeBetweenDates(this, this.user_uid, this.watch_id, this.type_id, interval.start, interval.end)
				.then(response => {
					this.$log.info(this.componentName, 'readings.getAllByTypeBetweenDates OK', response)()
					const readings = []
					response.body.forEach(element => {
						readings.push(new Reading(element))
					})
					this.readings.data = readings
				}).catch(error => {
					this.$log.error(this.componentName, 'readings.getAllByTypeBetweenDates ERROR', error)()
					this.readings.error = error
				}).finally(() => {
					this.readings.loading = false
				})
		},
		updateAlert () {
			this.$api.alerts.getWarnings(this, this.user_uid, this.watch_id,  this.type_id, this.alert_id)
				.then(response => {
					this.$log.info(this.componentName, 'alert.update OK', response)()
					response.body.forEach(item => {
						if (item.warning.reading_time) {
							return
						}

						const model = { id: item.warning.id, reading_time: this.$moment().format() }
						this.$api.warnings.update(this, this.user_uid, model)
							.then(response => {
								this.$log.info(this.componentName, 'alert.update OK', response)()
								this.$store.dispatch('getAccountAlerts', { context: this, user_uid: this.user_uid })
							}).catch(error => {
								this.$log.error(this.componentName, 'alert.update ERROR', error)()
							})
					})
				})
				.catch(error => {
					this.$log.error(this.componentName, 'alert.update ERROR', error)()
				})
		},
		isEmpty (obj) {
			return Object.keys(obj).length === 0 && obj.constructor === Object
		}
	},
	created () {
		const query = this.$route.query
		if (query && query.constructor === Object && Object.keys(query).length > 0) {
			if (query.action === 'update') {
				this.updateAlert()
				this.$store.dispatch('setUserSelectedAccount', this.user_uid)
			}
		}
		this.getResume()
	}
}
</script>



// WEBPACK FOOTER //
// src/components/watch/readings/shared/alertsV2/ReadingsAlertViewResume.vue